import Vue from 'vue'
import VueRouter from 'vue-router'
import { localizedSite } from '@/content/localizedSite'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'PageView',
    component: (resolve) => require(['@/views/PageView'], resolve),
    children: [
      { path: '/', redirect: '/index' },
      {
        path: '/index',
        name: 'index',
        component: (resolve) => require(['@/views/home'], resolve),
        meta: { pageKey: 'home', title: { zh: '首页', en: 'Home' } }
      },
      {
        path: '/product',
        name: 'product',
        component: () => import('@/views/product/index.vue'),
        meta: { pageKey: 'product', title: { zh: '核心产品', en: 'Platform' } }
      },
      {
        path: '/about',
        name: 'about',
        component: (resolve) => require(['@/views/about/detail.vue'], resolve),
        meta: { pageKey: 'about', title: { zh: '关于我们', en: 'About' } }
      },
      {
        path: '/contact',
        name: 'contact',
        component: (resolve) => require(['@/views/contact/index.vue'], resolve),
        meta: { pageKey: 'contact', title: { zh: '联系我们', en: 'Contact' } }
      },
      {
        path: '/en',
        name: 'enHome',
        component: (resolve) => require(['@/views/home'], resolve),
        meta: { pageKey: 'home', title: { zh: '首页', en: 'Home' } }
      },
      {
        path: '/en/product',
        name: 'enProduct',
        component: () => import('@/views/product/index.vue'),
        meta: { pageKey: 'product', title: { zh: '核心产品', en: 'Platform' } }
      },
      {
        path: '/en/about',
        name: 'enAbout',
        component: (resolve) => require(['@/views/about/detail.vue'], resolve),
        meta: { pageKey: 'about', title: { zh: '关于我们', en: 'About' } }
      },
      {
        path: '/en/contact',
        name: 'enContact',
        component: (resolve) => require(['@/views/contact/index.vue'], resolve),
        meta: { pageKey: 'contact', title: { zh: '联系我们', en: 'Contact' } }
      },
      { path: '/about/detail', redirect: '/about' },
      { path: '/product/medical', redirect: '/product' },
      { path: '/product/digitalize', redirect: '/product' },
      { path: '/en/index', redirect: '/en' },
      { path: '/en/about/detail', redirect: '/en/about' },
      { path: '/en/product/medical', redirect: '/en/product' },
      { path: '/en/product/digitalize', redirect: '/en/product' }
    ]
  },
  {
    path: '*',
    redirect: '/index'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  const lang = to.path.startsWith('/en') ? 'en' : 'zh'
  document.documentElement.lang = lang === 'en' ? 'en' : 'zh-CN'
  const title = to.meta.title && to.meta.title[lang]
  if (title) {
    document.title = `${title} - ${localizedSite[lang].company.name}`
  }
  next()
})

export default router
